export default function Django_For_Loop() {
  return <div>Django_For_Loop Component</div>;
}
